export const isString = (str: any) => typeof str === 'string' || str instanceof String;

export const trimLeft = (str: string, characters: string) => {
  if (!characters) {
    characters = 's';
  }
  return str.replace(new RegExp(`^[${characters}]+`), '');
};

export const trimRight = (str: string, characters: string) => {
  if (!characters) {
    characters = 's';
  }
  return str.replace(new RegExp(`[${characters}]+$`), '');
};

export const trim = (str: string, characters: string) => {
  str = trimLeft(str, characters);
  return trimRight(str, characters);
};
